export * from './prime.module';
